/**
 * Central design tokens for MP Plastic Industries.
 * Prefer these over hardcoded values in components.
 * CSS mirrors live in `src/index.css` (@theme).
 */

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const

export const Z_INDEX = {
  base: 0,
  raised: 10,
  sticky: 20,
  dropdown: 40,
  overlay: 45,
  modal: 50,
  toast: 60,
  max: 9999,
} as const

export const SPACING = {
  pageX: { mobile: 12, tablet: 28, desktop: 40 },
  pageY: { mobile: 12, tablet: 20, desktop: 24 },
  section: 16,
  card: 20,
} as const

export const ICON_SIZES = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24,
} as const

export const ELEVATION = {
  flat: 'shadow-none',
  xs: 'shadow-xs',
  card: 'shadow-card',
  elevated: 'shadow-elevated',
  float: 'shadow-float',
} as const

/** Shared page-content ceiling — only engages above 1920px (true ultrawide);
 * 1366–1920 desktops always get the full available width. Raised from 1480 in
 * Phase 2 so operational/data-dense pages aren't squeezed on large monitors. */
export const CONTENT_MAX_WIDTH = 1920

export type BreakpointKey = keyof typeof BREAKPOINTS
export type ZIndexKey = keyof typeof Z_INDEX
